import {
  Component,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  Renderer2,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { OrderBatch } from '@app/services/order-batch/order-batch.model';
import { FulfillService } from '../../fulfill.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'fulfill-batch-history-modal',
  templateUrl: './fulfill-batch-history-modal.component.html',
  styleUrls: ['./fulfill-batch-history-modal.component.scss'],
  standalone: false,
})
export class FulfillBatchHistoryModalComponent implements OnInit, OnDestroy {
  @Input() parent: any;
  @Output() onClose = new EventEmitter<void>();
  @ViewChild('modal') modal: ElementRef;

  windowClickListener: () => void;
  batches: OrderBatch[];
  count: number = 0;
  filterText;
  currentPage: number = 1;
  batchesPerPage: number = 10;
  totalPages: number = 1;
  searchParams$ = new Subject<string>();
  paginationOptions = [
    {
      label: 'Show 10',
      value: 10,
    },
    {
      label: 'Show 20',
      value: 20,
    },
  ];

  constructor(
    private fulfillService: FulfillService,
    private renderer: Renderer2,
  ) {}

  ngOnDestroy() {
    this.windowClickListener();
  }

  ngOnInit() {
    this.windowClickListener = this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.modal?.nativeElement.contains(e.target) && e.target !== this.parent.toggle.nativeElement) {
        this.onClose.emit();
      }
    });

    this.getBatchesHistory(this.currentPage - 1, this.batchesPerPage);

    this.initSearchSubject();
  }

  initSearchSubject(): void {
    this.searchParams$.pipe(debounceTime(500)).subscribe((value) => {
      this.getBatchesHistory(0, this.batchesPerPage, value);
    });
  }

  onPerPageChanges({ value }: any): void {
    this.batchesPerPage = value;
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.count / this.batchesPerPage);
    this.getBatchesHistory(0, this.batchesPerPage);
  }

  getBatchesHistory(currentPage: number, maxResults: number, searchParams: string = ''): void {
    this.fulfillService
      .getBatchesHistory({ currentPage: currentPage, maxResults: maxResults }, searchParams)
      .subscribe((res) => {
        this.batches = res.fullHistory;
        this.count = res.count;

        if (searchParams != '') {
          this.count = res.fullHistory?.length;
        }

        this.totalPages = Math.ceil(this.count / maxResults);
      });
  }

  paginate(page: number): void {
    this.currentPage = page + 1;
    this.getBatchesHistory(page, this.batchesPerPage);
  }

  filterBatches(text: string | undefined) {
    this.searchParams$.next(text);
  }
}
